import { expressList } from "@/mocks/kanliao";

export default function ExpressFeed() {
  return (
    <section id="express" className="scroll-mt-24 bg-background-50 py-14 md:py-20">
      <div className="mx-auto max-w-7xl px-5 md:px-8">
        <div className="flex flex-col gap-5 md:flex-row md:items-center md:justify-between">
          <div>
            <div className="flex items-center gap-2">
              <span className="inline-flex items-center gap-1.5 rounded-full bg-accent-500 px-3 py-1 text-xs font-bold text-foreground-950">
                <i className="ri-flashlight-fill" aria-hidden="true"></i>
                新料速递 · 实时
              </span>
            </div>
            <h2 className="mt-3 font-heading text-2xl font-black text-foreground-950 md:text-3xl">
              按分钟刷新的第一手新料
            </h2>
          </div>
          <div className="flex items-center gap-2 text-sm text-secondary-700">
            <span className="relative flex h-2.5 w-2.5">
              <span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-primary-400 opacity-75"></span>
              <span className="relative inline-flex h-2.5 w-2.5 rounded-full bg-primary-500"></span>
            </span>
            刚刚刷新 · 持续跟进中
          </div>
        </div>

        <div className="mt-7 flex flex-col overflow-hidden rounded-2xl bg-background-100 ring-1 ring-background-200">
          {expressList.map((item, idx) => (
            <article
              key={item.id}
              className={`group flex items-center gap-3 px-4 py-3.5 transition-colors hover:bg-background-200/60 md:gap-5 md:px-5 ${
                idx !== 0 ? "border-t border-background-200" : ""
              }`}
            >
              {/* new marker / time */}
              <div className="hidden w-16 shrink-0 items-center gap-1.5 sm:flex">
                {item.isNew ? (
                  <span className="flex items-center gap-1 whitespace-nowrap rounded-full bg-primary-100 px-2 py-0.5 text-[11px] font-bold text-primary-700">
                    <i className="ri-sparkling-fill text-xs" aria-hidden="true"></i>
                    {item.time}
                  </span>
                ) : (
                  <span className="whitespace-nowrap text-xs text-secondary-500">{item.time}</span>
                )}
              </div>

              {/* keyword chips */}
              <div className="flex w-24 shrink-0 flex-wrap content-center gap-1">
                {item.keyword.map((k) => (
                  <span
                    key={k}
                    className="whitespace-nowrap rounded-full bg-background-50 px-2 py-0.5 text-[11px] font-medium text-secondary-700 ring-1 ring-background-200"
                  >
                    {k}
                  </span>
                ))}
              </div>

              {/* title */}
              <h3 className="min-w-0 flex-1 text-sm font-medium leading-snug text-foreground-900 group-hover:text-primary-700 md:text-[15px]">
                {item.title}
              </h3>

              {/* source */}
              <span className="hidden shrink-0 items-center gap-1 text-xs text-secondary-600 lg:flex">
                <i className="ri-corner-down-left-line" aria-hidden="true"></i>
                {item.source}
              </span>
              {/* mobile new dot */}
              {item.isNew && <span className="flex h-2 w-2 shrink-0 rounded-full bg-primary-500 sm:hidden"></span>}
            </article>
          ))}
        </div>

        <p className="mt-5 text-center text-xs text-secondary-600">
          速递信息持续跟进中，事件如有反转将第一时间在对应条目内更新。
        </p>
      </div>
    </section>
  );
}